export function getLocations(filter, data) {
  let f = (l) =>
    l.images.length > 0 &&
    (filter.type == null || filter.type === l.totem_type) &&
    (filter.format == null ||
      filter.format === (l.is_big_screen ? 'big' : 'citylight'));
  if (filter.city != null) {
    return data.find((d) => d.city_id == filter.city)?.totems?.filter(f) || [];
  } else {
    let locs = [];
    data.forEach((d) => locs.push(...d.totems.filter(f)));
    return locs;
  }
}
